export const concatRoute = (parentRoute: string, childRoute: string) => {
  return `${parentRoute.slice(0, -1)}${childRoute}`;
};
